import React, { useContext, useRef, useCallback } from 'react'
import Webcam from 'react-webcam'

import WebcamContext from '../contexts/WebcamContext'
import { useInterval } from '../hooks'

const videoConstraints = {
  width: 640,
  height: 480,
  facingMode: 'user',
}
const WebcamPanel = () => {
  const { setImage } = useContext(WebcamContext)
  const webcamRef = useRef(null)
  const capture = useCallback(
    () => {
      setImage(webcamRef.current.getScreenshot())
    },
    [webcamRef, setImage]
  )
  useInterval(() => {
    capture()
  }, 200)
  return (
    <Webcam
      audio={false}
      width={640}
      height={480}
      ref={webcamRef}
      screenshotFormat="image/jpeg"
      videoConstraints={videoConstraints}
    />
  )
}

export default WebcamPanel
